import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgILockClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-20 -20 560 560",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M336 208v-95a80 80 0 00-160 0v95",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 32
	}), /* @__PURE__ */ _jsx("rect", {
		x: 96,
		y: 208,
		width: 320,
		height: 272,
		rx: 48,
		ry: 48,
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 32
	})]
});
export default SvgILockClosed;
